import { Component } from 'react'
import { ErrorMessage, emptyField, errorsLength, formatErrors } from '../../../../../../insfrastructure/utils/form-validators'
import { StaticValues } from '../../../../../../insfrastructure/services/static_values'
import { CreateCandidate, retrieveCandidate, updateCandidate } from '../../../../../../insfrastructure/services/candidates'
import { Input } from '../../../../../components/input'
import { SubmitBtn } from '../../../../../components/submit'
import ConfirmationModal from '../../../../../components/confimation-modal'
import { Select } from '../../../../../components/select'
import { generateKey } from '../../../../../../insfrastructure/utils/array-key'
import './styles.sass'

interface SkillOption {
  value: number,
  label: string,
  category: string,
  description: string,
  disabled?: boolean
}

interface State {
    skills: {
        id: number | null;
        editing: boolean;
    }[];
    skills_options: SkillOption[];
    static_skills: { 
        id: number,
        name: string,
        description: string,
        category: 'Solf' | 'Hard',
        category_id: number
    }[]
}

export default class Skills extends Component<{ skill_category: "Soft" | "Hard" }> {
  state: State = {
    skills: [
      {
        id: null,
        editing: false
      }
    ],
    skills_options: [],
    static_skills: []
  }

  async componentDidMount() {
    await this.getStaticValues();
  }

  async componentDidUpdate(prevProps: Readonly<{ skill_category: 'Soft' | 'Hard' }>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.skill_category !== this.props.skill_category) {
      await this.getStaticValues();
    };
  }

  getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        const static_skills = staticValues.skills;
        
        this.setState({ static_skills }, () => this.retrieveCandidateSkills(true));
      });
    } catch (error) {}
  }

  retrieveCandidateSkills = async (retrieve?: boolean) => {
    try {
      const candidate = await retrieveCandidate();

      const skills_options = this.state.static_skills.filter(x => x.category === this.props.skill_category)
      .map(x => ({
        value: x.id,
        label: x.name,
        category: x.category,
        description: x.description,
        disabled: candidate.skills.includes(x.id)
      }));

      const skills = [...skills_options]
      .filter((skill: any) => candidate.skills.includes(skill.value) && skill.category === this.props.skill_category )
      .map((skill: any) => ({ id: skill.value, editing: false }))

      this.setState({ 
        skills_options,
        skills
      });
    } catch (error) {}
  }

  addSkill = () => {
    const items = [...this.state.skills];
    items.push({
      id: null,
      editing: true
    });

    this.setState({ skills: items });
  }

  editSkill = async (index: number) => {
    const items = [...this.state.skills].map((x, i) => {
      if(index === i) {
        x.editing = true;
      };
    
      return x;
    });

    this.setState({ skills: items });
  }

  onSubmitSkill = async (skill_id: any, index: number) => {
    const skills = [...this.state.skills];

    skills[index].id = skill_id;
    skills[index].editing = false;

    const index_found = this.state.skills_options.indexOf(this.state.skills_options.filter((option) => option.value === skill_id)[0]);
    const skills_options = [...this.state.skills_options];
    skills_options[index_found].disabled = true;

    this.setState({ skills, skills_options });

    this.updateSkills();
  }

  removeSkill = async (index: number) => {
    const items = [...this.state.skills].filter((_: any, i: number) => index !== i);

    const skill_id = this.state.skills[index].id;
    const index_found = this.state.skills_options.indexOf(this.state.skills_options.filter((option) => option.value === skill_id)[0]);
    const skills_options = [...this.state.skills_options];
    skills_options[index_found].disabled = false;
  
    this.setState({ skills: [] }, () => this.setState({ skills: items }));

    this.updateSkills();
  }

  updateSkills = async () => {
      try {
        const candidate = await retrieveCandidate() as any as CreateCandidate;

        const other_skills_options = this.state.static_skills.filter(x => x.category !== this.props.skill_category);

        const skills_of_other_type =
        other_skills_options.filter((skill: any) => 
        candidate.skills.includes(skill.id) && skill.category !== this.props.skill_category).map((skill: any) => skill.id);

        const skills_of_current_type = this.state.skills.map(x => x.id) as number[];

        candidate.skills = [...skills_of_other_type, ...skills_of_current_type].filter(id => id !== null);

        !candidate.escola_do_mecanico_id && delete candidate.escola_do_mecanico_id;

        await updateCandidate(localStorage.getItem('candidate_id')+'', candidate);

        // this.retrieveCandidateSkills();
      } catch (error) {
        
      }
  }

  render() {
    return (
      <div className='skills-section'>
        <h1>{this.props.skill_category} Skills</h1>
        <div className='skills'>
          {
            this.state.skills.length > 0 ?
            this.state.skills.map((x: any, index: number) =>
            <SkillsForm
            key={generateKey('skill_'+index)}
            skill_id={x.id}
            readonly={!x.editing}
            skills_options={this.state.skills_options}
            onAdd={(skill_id) => this.onSubmitSkill(skill_id, index)}
            onUpdate={() => this.editSkill(index)}
            onRemove={() => this.removeSkill(index)} />) :
            <div className='empty-list'>
              <p>Nenhuma skill adicionada</p>
            </div>
          }
        </div>
        {
          this.state.skills.filter(skill => !skill.id).length === 0 &&
          <SubmitBtn className='secondary' text={`Adicionar ${this.props.skill_category} Skill`} onSubmit={this.addSkill} />}
      </div>
    )
  }
}

interface SkillsFormState {
  form: {
    skill_id: number | null,
    description: string
  },
  formErrors: Record<string, any>,
  loading: boolean,
  selectedItemToDelete: boolean
}

class SkillsForm extends Component
<{skill_id: number | null, onAdd: (skill_id: number) => any, onUpdate: () => any, onRemove: () => void, skills_options: SkillOption[], readonly: boolean}> {
  state: SkillsFormState = {
    form: {
      skill_id: null,
      description: ''
    },
    formErrors: {},
    loading: false,
    selectedItemToDelete: false
  }

  componentDidMount() {
    if(this.props.skill_id) {
      this.setState({ 
        form: {
          skill_id: this.props.skill_id
        } 
      });

      this.onSelect(this.props.skill_id);
    };
  }

  onSelect = (skill_id: any) => {
    const selected_skill_filter = this.props.skills_options.filter(x => x.value === skill_id);
    const selected_skill_description = selected_skill_filter.length > 0 ? selected_skill_filter[0].description : ''

    this.setState({ form: { ...this.state.form, skill_id, description: selected_skill_description } })
  }

  onSubmit = async () => {
    const errors = formatErrors({
      skill_id: [emptyField(this.state.form.skill_id, 'number')]
    });

    this.setState({ formErrors: errors });
  
    if(errorsLength(errors) > 0) return;

    this.setState({ loading: true });

    try {
        this.props.onAdd(this.state.form.skill_id as number);
        
        setTimeout(() => {
            this.setState({ loading: false });
        });
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  onRemoveInterest = () => {
    if (!this.state.form['skill_id']) {
      this.props.onRemove();
      
      return;
    };

    this.setState({ selectedItemToDelete: true });
  }

  onRemoveConfirmation = async () => {
    this.setState({ loading: true });
    this.setState({ selectedItemToDelete: null });

    try {
        setTimeout(() => {
          this.setState({ loading: false });
          this.props.onRemove();
        });
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div className='form'>
        <div className='columns-group'>
          <div className='full-width-column'>
            <Select
            name='skill_id'
            label='Habilidade'
            placeholder='Habilidade'
            value={this.state.form['skill_id']}
            options={this.props.skills_options}
            readonly={this.props.readonly}
            onChange={(value) => {              
              this.onSelect(value);
            }}/>
            <ErrorMessage errors={this.state.formErrors['skill_id']} />
          </div>
          <div className='full-width-column'>
            <Input
            name='name'
            type='textarea'
            label='Descrição'
            value={this.state.form['description']}
            placeholder='Descrição'
            readonly={true}/>
          </div>
        </div>
        <div className='btns'>
          {!this.props.readonly &&
          <SubmitBtn className='secondary' text='Salvar Alterações' loadingText='Salvando...' loading={this.state.loading} onSubmit={this.onSubmit} />}
          {this.props.readonly &&
          <SubmitBtn className='secondary' text='Editar' onSubmit={() => this.props.onUpdate()} />}
          {<SubmitBtn className='secondary' text='Remover' loadingText='Removendo...' loading={this.state.loading} onSubmit={this.onRemoveInterest} />}
        </div>
        <ConfirmationModal
        title='Deletar esse skill?'
        text='Tem certeza que deseja deletar esse skill?'
        render={this.state.selectedItemToDelete}
        onConfirm={this.onRemoveConfirmation}
        onClose={() => this.setState({ selectedItemToDelete: false })}/>
      </div>
    )
  }
}

